export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/a70fe28c30edbe909cade8425716fdee.svg";